/**
 * 线上环境
 */
export const ONLINEHOST = 'https://www.ahdhst.com/oa-api/' //业务请求
// export const ONLINEHOST = 'http://192.168.20.55:8191/' //业务请求测试库
//  export const ONLINEHOST = 'http://192.168.30.104:8191/' //业务请求测试库

export const ONLINEUPLOADHOST = 'https://dtools.ahdhst.com/dfs/' //上传请求
export const PROCESSONLINE = "https://www.ahdhst.com/wf-api/" //流程模块
/**
 * 测试环境
 */
export const QAHOST = 'http://192.168.20.55:8191/' //业务请求
export const QAUPLOADHOST = 'http://192.168.1.89:9081/' //上传请求
export const PROCESSQA = "http://192.168.1.159:8890/" //流程模块

/**
 * 本地调试测试环境    
 */
//  export const DEVHOST = 'http://112.30.60.51:8191/' //测试环境业务公网请求

//  export const DEVHOST = 'http://192.168.30.104:8191/' //测试环境业务
export const DEVHOST = 'http://192.168.20.55:8191/' //测试环境业务请求?
// export const DEVHOST = 'http://oa.api.ahdhst.cn/' //测试生产环境业务请求
//  export const DEVHOST = 'http://192.168.20.96:8191/' //陈国贵
//export const DEVHOST = 'http://192.168.1.159:8889/' //刘伟
// export const DEVHOST = 'http://192.168.21.223:8191/' //张涛山

//  export const DEVHOST = 'http://192.168.21.225:8191/' //肖东
//  export const DEVHOST = 'http://192.168.20.10:8191/' //肖东测试

export const DEVUPLOADVHOST = 'http://192.168.1.89:9081/' //测试环境上传接口
export const PROCESSDEV = "http://192.168.1.159:8890/" //流程模块

/**
 * 
 * 当前的host  ONLINEHOST | QAHOST | MOCKHOST
 */
//业务请求主机
export const MAINHOST =
  process.env.NODE_ENV === 'development' ?
    DEVHOST :
    process.env.VUE_APP_FLAG === 'pro' ?
      ONLINEHOST :
      QAHOST

//上传请求主机
export const UPLOADHOST =
  process.env.NODE_ENV === 'development' ?
    DEVUPLOADVHOST :
    process.env.VUE_APP_FLAG === 'pro' ?
      ONLINEUPLOADHOST :
      QAUPLOADHOST

//流程中心主机
export const PROCESSHOST =
  process.env.NODE_ENV === 'development' ?
    PROCESSDEV :
    process.env.VUE_APP_FLAG === 'pro' ?
      PROCESSONLINE :
      PROCESSQA
//跳转路由链接 
export const LocationHref = process.env.VUE_APP_FLAG === 'pro' ?
  'https://www.ahdhst.com/OA-pageH5/#/' : 'http://116.62.218.134:8089/slbktest/OA-pageH5/#/'
/**
 * @description token在Cookie中存储的天数，默认1天
 */
export const cookieExpires = 1